import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import {
  ACTION_ADD_CATEGORIES,
  ACTION_ADD_TEMPLATE_TO_CATEGORIES_MAP,
  ACTION_ADD_DEFAULT_SITE_FOOTER_LINK_CATEGORY_TRANSLATIONS,

  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__SUCCESS,
  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__FAIL,
  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__REQUEST,

  ACTION_SET_IS_SITE_LINK_CATEGORIES_MAX_NUMBER_REACHED,
} from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_CATEGORIES:
      return action.payload.categories;

    default:
      return state;
  }
};

const wlTemplateToManifestMap = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_TEMPLATE_TO_CATEGORIES_MAP: {
      return action.payload.wlTemplateToManifestMap;
    }

    default:
      return state;
  }
};

const isBeingDeleted = (state = {}, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__REQUEST:
      return { ...state, [action.payload.categoryId]: true };

    case ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__SUCCESS:
    case ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__FAIL:
      return _omit(state, action.payload.categoryId);

    default:
      return state;
  }
};

const isSiteLinkCategoriesMaxNumberReached = (state = null, action) => {
  switch (action.type) {
    case ACTION_SET_IS_SITE_LINK_CATEGORIES_MAX_NUMBER_REACHED:
      return action.payload.siteLinkCategoriesMaxNumberReached;

    default:
      return state;
  }
};

const wlTemplateToPromotedSiteToLangToCategoryToTranslationMap = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_DEFAULT_SITE_FOOTER_LINK_CATEGORY_TRANSLATIONS:
      return action.payload.wlTemplateToPromotedSiteToLangToCategoryToTranslationMap;

    default:
      return state;
  }
};

export default combineReducers({
  byId,
  isBeingDeleted,
  wlTemplateToManifestMap,
  wlTemplateToPromotedSiteToLangToCategoryToTranslationMap,
  isSiteLinkCategoriesMaxNumberReached,
});
